var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophoneOn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bright mode=On, Size=24 pixels, Type=Outline, State=Hover"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 12.049C15.75 14.073 14.067 15.722 12 15.722C9.933 15.722 8.25 14.073 8.25 12.049V6.173C8.25 4.149 9.933 2.5 12 2.5C14.067 2.5 15.75 4.149 15.75 6.173V12.049ZM9.75 6.173C9.75 4.958 10.76 3.97 12 3.97C13.24 3.97 14.25 4.958 14.25 6.173V12.049C14.25 13.264 13.24 14.253 12 14.253C10.76 14.253 9.75 13.264 9.75 12.049V6.173ZM18.75 9.379V12.227C18.75 15.532 16.12 18.261 12.75 18.617V20.031H14.638C15.052 20.031 15.388 20.36 15.388 20.766C15.388 21.171 15.052 21.5 14.638 21.5H9.002C8.588 21.5 8.252 21.171 8.252 20.766C8.252 20.36 8.588 20.031 9.002 20.031H11.25V18.617C7.88 18.261 5.25 15.532 5.25 12.227V9.379C5.25 8.974 5.586 8.645 6 8.645C6.414 8.645 6.75 8.974 6.75 9.379V12.227C6.75 14.964 9.105 17.191 12 17.191C14.895 17.191 17.25 14.964 17.25 12.227V9.379C17.25 8.974 17.586 8.645 18 8.645C18.414 8.645 18.75 8.974 18.75 9.379Z",
    fill: "#142966"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOn);
export default __webpack_public_path__ + "static/media/MicrophoneOn.87224aa285a37ea0ebcfdf0ece49348e.svg";
export { ForwardRef as ReactComponent };